var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42857 0C6.76956 0 7.09659 0.135459 7.33771 0.376577C7.57883 0.617695 7.71429 0.944722 7.71429 1.28571V3.42857H16.2857V1.28571C16.2857 0.944722 16.4212 0.617695 16.6623 0.376577C16.9034 0.135459 17.2304 0 17.5714 0C17.9124 0 18.2394 0.135459 18.4806 0.376577C18.7217 0.617695 18.8571 0.944722 18.8571 1.28571V3.42857H22.2857C22.7404 3.42857 23.1764 3.60918 23.4979 3.93067C23.8194 4.25216 24 4.6882 24 5.14286V22.2857C24 22.7404 23.8194 23.1764 23.4979 23.4979C23.1764 23.8194 22.7404 24 22.2857 24H1.71429C1.25963 24 0.823593 23.8194 0.502103 23.4979C0.180612 23.1764 0 22.7404 0 22.2857V5.14286C0 4.6882 0.180612 4.25216 0.502103 3.93067C0.823593 3.60918 1.25963 3.42857 1.71429 3.42857H5.14286V1.28571C5.14286 0.944722 5.27832 0.617695 5.51943 0.376577C5.76055 0.135459 6.08758 0 6.42857 0ZM2.57143 6V8.57143H21.4286V6H2.57143ZM2.57143 21.4286V11.1429H21.4286V21.4286H2.57143ZM17.1429 17.1429C17.5975 17.1429 18.0335 16.9622 18.355 16.6408C18.6765 16.3193 18.8571 15.8832 18.8571 15.4286C18.8571 14.9739 18.6765 14.5379 18.355 14.2164C18.0335 13.8949 17.5975 13.7143 17.1429 13.7143C16.6882 13.7143 16.2522 13.8949 15.9307 14.2164C15.6092 14.5379 15.4286 14.9739 15.4286 15.4286C15.4286 15.8832 15.6092 16.3193 15.9307 16.6408C16.2522 16.9622 16.6882 17.1429 17.1429 17.1429Z",
    fill: "#274137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date_icon.80de4caad9984061fbc62415d1a2d341.svg";
export { ForwardRef as ReactComponent };